
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class vToggleSwitchSelfHandled extends Vue {

  @Prop() item: any;
  @Prop() isChecked!: boolean;
  @Prop({ default: 'default' }) className: string ;

  changeHandler() {
    this.$emit('vToggleSwitchSelfHandled:changed', this.item);
  }

}
